import { LearningPathsSubpage } from './LearningPathsSubpage';
import { useLearningPathsData } from './useLearningPathsData';
import { SIDEBAR_ITEMS } from './useSidebarItems';

export const LearningPathsRecommended = () => {
  const { recommendedLps, organizationName, isLoading } =
    useLearningPathsData();

  return (
    <LearningPathsSubpage
      title={SIDEBAR_ITEMS.RECOMMENDED}
      subtitle={`Hand-picked for you by the team at ${organizationName}`}
      learningPaths={recommendedLps}
      organizationName={organizationName}
      isLoading={isLoading}
    />
  );
};
